/* eslint-disable import/prefer-default-export */
import { sendIntakeAgentMessage } from "../../../api/agentic/intakeAgentApi";
import { sendBenefitAgentMessage } from "../../../api/agentic/benefitAgentApi";

import { normalizeIntakeResponse } from "./intakeNormalizer";
import { normalizeBenefitResponse } from "./benefitNormalizer";
import { uploadCaseDocuments } from "../../../api/agentic/documentAgentApi";
import { normalizeDocumentAgentResponse } from "./docAgentNormalizer";
import { sendEligibilityReviewAgentMessage } from "../../../api/agentic/eligibilityReviewAgentApi";
import { normalizeEligibilityResponse } from "./eligibilityNormalizer";

export const AGENTS = {
  "Intake Review Agent": {
    id: "review-intake-a1",
    sendMessage: sendIntakeAgentMessage,
    normalize: normalizeIntakeResponse,
    streamKeys: [ "error.message", "summary"],
    agent_name: "IntakeReviewAgent",
  },

  "Application Status Agent": {
    id: "application-status-agent",
    sendMessage: sendIntakeAgentMessage,
    normalize: normalizeIntakeResponse,
    agent_name: "IntakeReviewAgent",
  },

  "Benefits Agent": {
    id: "benefit-agent-b1",
    sendMessage: sendBenefitAgentMessage,
    normalize: normalizeBenefitResponse,
    streamKeys: [ "error.message","summary"],
    agent_name: "DOBAgentMulti",
  },

  "Document Quality Agent": {
    id: "DocumentProcessingAgent",
    agent_name: "DocumentProcessingAgent",
    sendMessage: uploadCaseDocuments,
    normalize: normalizeDocumentAgentResponse,
  },

  "Duplicate Report": {
    id: "review-intake-a1",
    sendMessage: sendIntakeAgentMessage,
    normalize: normalizeIntakeResponse,
    agent_name: "IntakeReviewAgent",
  },

  "Benefits Report": {
    id: "benefit-agent-b1",
    sendMessage: sendBenefitAgentMessage,
    normalize: normalizeBenefitResponse,
    // streamKeys: [ "error.message", "response"],
    agent_name: "DOBAgentMulti",
  },

  "Eligibility Review Agent": {
    id: "eligibility-review-agent-e1",
    sendMessage: sendEligibilityReviewAgentMessage,
    normalize: normalizeEligibilityResponse,
    streamKeys: [ "error.message", "response.response"],
    agent_name: "EligibilityReviewAgent",
  },

};
